import { AxiosError } from "axios";

/**
 * axiosBaseQuery - create base query for RTK api
 * @param {import("axios").AxiosInstance} axiosInstance - Pass the axios instance
 *
 * @template T
 * @typedef {import("@reduxjs/toolkit/query").BaseQueryFn<T, unknown, unknown>} BaseQueryFn<T>
 *
 * @returns {BaseQueryFn<import("axios").AxiosRequestConfig>} - Returns a base query function for RTK api
 */
export const axiosBaseQuery = (axiosInstance) => {
  /** @param {import("axios").AxiosRequestConfig} params */
  return async ({ url, method, data, params, headers, ...rest }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
        ...rest,
      });
      return { data: result?.data, meta: { status: result?.status } };
    } catch (axiosError) {
      if (axiosError instanceof AxiosError) {
        return {
          error: {
            status: axiosError.response?.status,
            data: axiosError.response?.data || axiosError.message,
          },
        };
      }
      return { error: { status: "FETCH_ERROR", data: axiosError } };
    }
  };
};
